import { formHelperTextClasses, outlinedInputClasses, ThemeOptions } from '@mui/material';
import { radius } from 'themes/radius';

export const generateTextFieldThemeOptions = (): ThemeOptions['components'] => ({
  MuiOutlinedInput: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      notchedOutline: ({ theme }) => ({
        borderColor: theme.palette.grey[800],
        borderRadius: radius.none,
      }),
      root: ({ theme }) => ({
        [`&:hover .${outlinedInputClasses?.notchedOutline}`]: {
          borderColor: theme.palette.grey[800],
          borderWidth: '2px',
        },
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses?.notchedOutline}`]: {
          borderColor: theme.palette.grey[800],
          borderWidth: '2px',
        },
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses?.notchedOutline}`]: {
          borderColor: theme.palette.error.main,
        },
      }),
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: ({ theme }) => ({
        marginLeft: '0px',
        [`&:not ${formHelperTextClasses.error}`]: {
          color: theme.palette.grey[700],
        },
      }),
    },
  },
});
